module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "static-info"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', {
    staticClass: "static-info--heading"
  }, [_vm._v("sk club and Movie Cards")]), _vm._v(" "), _c('h3', [_vm._v("Get the most out of all ster-kinekor movie benefits")])]), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Discovery_Vitality') ? [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("DISCOVERY VITALITY")]), _vm._v(" "), _c('p', [_vm._v("\n                    Experience the latest movies for half the price after activating your Vitality Ster-Kinekor movie benefit.\n                  ")])])], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "vitality-club-benefits",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    staticClass: "benefit",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('div', {
    staticClass: "sk-club__join"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v("\n                                    GET 50% OFF A 2D, "), _c('br'), _vm._v(" \n                                    A 3D AND A "), _c('br'), _vm._v(" \n                                    CINEMA NOUVEAU "), _c('br'), _vm._v("\n                                    TICKET.\n                                  ")])])])])], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "benefit",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('div', {
    staticClass: "sk-club__join"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v("\n                                    VITALITY KIDS BETWEEN "), _c('br'), _vm._v("\n                                    2 AND 18 YEARS OLD "), _c('br'), _vm._v("\n                                    CAN WATCH 2D AND 3D MOVIES \n                                    FOR FREE AT SELECTED \n                                    CINEMAS BEFORE 7PM.*\n                                  ")])])])])], 1), _vm._v(" "), _c('sk-flex', {
    staticClass: "benefit",
    attrs: {
      "xs12": "",
      "sm12": "",
      "md4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('div', {
    staticClass: "sk-club__join"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v("\n                                    GET 25% OFF CINE PRESTIGE, NT LIVE OR IMAX MOVIE TICKETS.\n                                  ")])])])])], 1)], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "vitality-club-benefits",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_vm._v("\n                    *Complete the Kids Vitality Health Review every 12 months to keep the Vitality Kids movie "), _c('br'), _vm._v("\n                    benefit. You can access the Kids Vitality Health Review assessment on the \"Know your "), _c('br'), _vm._v("\n                    Health\" page on "), _c('a', {
    attrs: {
      "href": "http://www.discovery.co.za",
      "target": "_blank"
    }
  }, [_vm._v("www.discovery.co.za")])]), _vm._v(" "), _c('p', [_vm._v("\n                    *Vitality Kids get 25% off Cine Prestige, NT Live or IMAX movie tickets.\n                  ")]), _vm._v(" "), _c('p', [_c('br'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tag": "a",
      "primary": "",
      "href": "https://www.discovery.co.za/discovery_coza/web/linked_content/pdfs/vitality/benefit_rules/ster_kinekor_benefit_guide.pdf",
      "target": "_blank"
    }
  }, [_vm._v("View the Vitality Movie Benefit Guide")])], 1)])], 1)], 1), _vm._v(" "), _c('sk-panel', {
    staticClass: "vitality-black-panel",
    attrs: {
      "black": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {}, [_vm._v("\n                    Get the Vitality Ster-Kinekor digital card and always have your movie card "), _c('br'), _vm._v("\n                    on your iPhone or Android smartphone.\n                  ")])])], 1)], 1), _vm._v(" "), _c('sk-panel', [_c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("HOW TO GET YOUR DIGITAL CARD")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.$breakpoints.xs || _vm.$breakpoints.sm || _vm.$breakpoints.md) ? [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [_c('ol', [_c('li', [_vm._v("Download the latest version of the Discovery app and activate the Vitality Ster-Kinekor movie benefit.")]), _vm._v(" "), _c('li', [_vm._v("Once you've activated the benefit, you can access your digital Vitality Ster-Kinekor movie card in the digital cards section on the main menu.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("IOS users")]), _vm._v(" can view their digital cards on the Apple Wallet app.\n                      ")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/vitality-phone.png"
    }
  })])] : [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "article__content"
  }, [_c('ol', [_c('li', [_vm._v("Download the latest version of the Discovery app and activate the Vitality Ster-Kinekor movie benefit.")]), _vm._v(" "), _c('li', [_vm._v("Once you've activated the benefit, you can access your digital Vitality Ster-Kinekor movie card in the digital cards section on the main menu.")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("IOS users")]), _vm._v(" can view their digital cards on the Apple Wallet app.\n                      ")])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/vitality-phone.png"
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md1": ""
    }
  })]], 2)], 1), _vm._v(" "), _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.$route.path === '/club-loyalty/Discovery_Vitality') ? _c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Have a look at our vitality pricing guide")]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Edgars_Club') ? _c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Have a look at our Edgars Club price list")]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "select-cinema"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a cinema")]), _vm._v(" "), (_vm.cinemas) ? _c('sk-combo-select', {
    staticClass: "cinema-select form-group",
    attrs: {
      "options": _vm.cinemas,
      "track-by": "cinema",
      "label": "cinema",
      "searchable": false,
      "placeholder": "Choose A Cinema",
      "multiple": false
    },
    model: {
      value: (_vm.cinema_selected),
      callback: function($$v) {
        _vm.cinema_selected = $$v
      },
      expression: "cinema_selected"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.cinema_selected != null) ? _c('div', {
    staticClass: "select-cinema-type"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a cinema type")]), _vm._v(" "), _c('div', {
    staticClass: "detail-experience"
  }, [_c('sk-list', [_c('sk-list-tile', [_c('sk-list-tile-action', [_c('span', {
    staticClass: "label label--large",
    class: _vm.active2d ? 'label--active' : '',
    on: {
      "click": function($event) {
        _vm.selectCinemaType(_vm.cinema_selected['2d_vitality'], _vm.cinema_selected['2d_edgars'], _vm.cinema_selected['2d_full_price'], _vm.active2d = true, _vm.active3d = false)
      }
    }
  }, [_vm._v("2D")])])], 1), _vm._v(" "), _c('sk-list-tile', [_c('sk-list-tile-action', [_c('span', {
    staticClass: "label label--large",
    class: _vm.active3d ? 'label--active' : '',
    on: {
      "click": function($event) {
        _vm.selectCinemaType(_vm.cinema_selected['3d_vitality'], _vm.cinema_selected['3d_edgars'], _vm.cinema_selected['3d_full_price'], _vm.active3d = true, _vm.active2d = false)
      }
    }
  }, [_vm._v("3D")])])], 1)], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs2": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "prices"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Prices")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "prices-box"
  }, [_c('span', [_vm._v("Full Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fullPrice))])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "prices-box card-name-block"
  }, [(_vm.$route.path == '/club-loyalty/Edgars_Club') ? [_c('span', [_vm._v("Edgars Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.edgarsPrice))])] : _vm._e(), _vm._v(" "), (_vm.$route.path == '/club-loyalty/Discovery_Vitality') ? [_c('span', [_vm._v("Vitality Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.vitalityPrice))])] : _vm._e()], 2)])], 1)], 1)])], 1), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Discovery_Vitality' && _vm.showOtherPricing) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Other pricing")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Cinema Nouveau")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Full Price")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R80,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Vitality")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R40,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item"
  }, [_vm._v("Opera")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("NT Live")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Prestige 2D/3D")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("IMAX 2D/3D")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R110,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R156,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R140,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R129,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R60,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R105,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R76,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R72,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("IMAX 3D Glasses")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Vitality Welcome Pack")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Vitality Replacement Pack")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Adults)")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Kids)")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R16,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R44,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R32,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R12,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R11,00")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "inline-block": "",
      "primary": "",
      "tag": "a",
      "href": "#discovery-form"
    }
  }, [_vm._v("Activate Discovery Vitality Now")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Edgars_Club' && _vm.showOtherPricing) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Other pricing")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Cinema Nouveau")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Full Price")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R80,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Edgars Club")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R40,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item"
  }, [_vm._v("Opera")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("NT Live")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Prestige 2D/3D")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("IMAX 2D/3D")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R110,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R156,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R140,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R129,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R68,50")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R118,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R86,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R86,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("IMAX 3D Glasses")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Adults)")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Kids)")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Edgars Activation")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R16,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R12,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R11,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R30,00")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "inline-block": "",
      "primary": "",
      "tag": "a",
      "href": "http://www.edgarsclub.co.za/benefits/do-more/ster-kinekor/",
      "target": "_blank"
    }
  }, [_vm._v("Visit Edgars Online To Find Out More")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('sk-signin')] : [(_vm.page.section_1) ? _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_1.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "club-movie-cards"
  }, [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_1.body)
    }
  }), _vm._v(" "), (_vm.page.section_1.button_text) ? _c('div', {
    staticClass: "club-movie-cards__buttons"
  }, [(_vm.isGuest) ? _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'user',
        params: {
          signInType: 'signup'
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.page.section_1.button_text))]) : (_vm.user.MemberLevelId == '19') ? _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": "/user/profile#join"
    }
  }, [_vm._v(_vm._s(_vm.page.section_1.button_text))]) : _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": {
        name: 'profile'
      }
    }
  }, [_vm._v("Dashboard")]), _vm._v(" "), (!_vm.isGuest) ? _c('sk-button', {
    attrs: {
      "secondary": "",
      "router": "",
      "loading": _vm.loadingResendActivation
    },
    on: {
      "native": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "click", undefined, $event.key)) { return null; }
        _vm.resendVerification()
      }
    }
  }, [_vm._v("Send Activation link")]) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [(_vm.page.section_1.image != undefined && _vm.page.section_1.image != null) ? [(_vm.page.section_1.image.url) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.page.section_1.image.url
    }
  })]) : _vm._e()] : [(_vm.page.section_1.mobile_image != undefined && _vm.page.section_1.mobile_image != null) ? [(_vm.page.section_1.mobile_image.url) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.page.section_1.mobile_image.url
    }
  })]) : _vm._e()] : _vm._e()]], 2)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.page.section_2) ? _c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "featured-info"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_2.body)
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.page.section_3) ? _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_3.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "club-movie-cards"
  }, [_c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_3.body)
    }
  }), _vm._v(" "), (_vm.page.section_3.button_text) ? _c('div', {
    staticClass: "club-movie-cards__buttons"
  }, [_c('sk-button', {
    attrs: {
      "block": _vm.$breakpoints.xs,
      "tertiary": "",
      "tag": "a",
      "target": _vm.$route.path === '/club-loyalty/Edgars_Club' ? '_blank' : '',
      "href": _vm.page.section_3.button_link
    }
  }, [_vm._v(_vm._s(_vm.page.section_3.button_text))]), _vm._v(" "), (_vm.page.section_3.additional_button_text) ? _c('sk-button', {
    attrs: {
      "block": _vm.$breakpoints.xs,
      "primary": "",
      "tag": "a",
      "href": _vm.page.section_3.additional_button_link
    }
  }, [_vm._v(_vm._s(_vm.page.section_3.additional_button_text))]) : _vm._e()], 1) : _vm._e()])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.page.section_4) ? _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', {
    staticClass: "static-info--sub-heading",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_4.heading)
    }
  })]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content "
  }, [(_vm.page.section_5.image.url) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.page.section_5.image.url
    }
  })]) : _vm._e(), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_5.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_5.body)
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "article__content "
  }, [(_vm.page.section_6.image.url) ? _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.page.section_6.image.url
    }
  })]) : _vm._e(), _vm._v(" "), _c('h4', {
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_6.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "article__content",
    domProps: {
      "innerHTML": _vm._s(_vm.page.section_6.body)
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/SK_Club') ? _c('div', [_c('div', {
    staticClass: "sk-club__section"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__join"
  }, [_c('h3', [_vm._v("Join For Free")]), _vm._v(" "), _c('h2', {
    staticClass: "h1"
  }, [_vm._v("200 Points")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "inline-block": "",
      "tertiary": "",
      "router": "",
      "to": {
        path: '/user/signup'
      }
    }
  }, [_vm._v("Join Now")])], 1)])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__special-treatment"
  }, [_c('h2', [_vm._v("Get special treatment")]), _vm._v(" "), _c('p', [_vm._v("SK Club members enjoy "), _c('strong', [_vm._v("Access Rewards")]), _vm._v(" such as exclusive invitations to pre-screenings and events, the SK Club lounge at Gateway and Eastgate, and pre-bookings for SK Club exclusive events.")])])])], 1)], 1), _vm._v(" "), _c('sk-spacer', {
    attrs: {
      "height": "10"
    }
  }), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/sk-club/half-price-tuesdays.png",
      "alt": "1/2 Price Tuesdays"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_vm._v("1/2 Price Tuesdays")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("Get 50% off any movie (excluding D-Box seats), all day on Tuesday")])])])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/sk-club/birthday-ticket.png",
      "alt": "Birthday Ticket"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_vm._v("Birthday Ticket")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("Get a free 2D / 3D ticket on your birthday (Valid for 7 Days)  "), _c('a', {
    attrs: {
      "href": "/content/legal/club-terms-and-conditions"
    }
  }, [_vm._v("T&C apply")])])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__section sk-club__points"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('h2', {
    staticClass: "sk-club__points--heading"
  }, [_vm._v("How to burn and earn points")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md7": ""
    }
  }, [_c('sk-panel', [_c('div', {
    staticClass: "sk-club__points-burn"
  }, [_c('h3', {
    staticClass: "sk-club__points--heading"
  }, [_vm._v("Burn Points")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-icon"
  }, [_c('sk-icon', {
    attrs: {
      "popcorn": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('h5', {
    staticClass: "sk-club__points--title"
  }, [_vm._v("400 Points")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_vm._v("Free Regular Popcorn")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-icon"
  }, [_c('sk-icon', {
    attrs: {
      "combo": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('h5', {
    staticClass: "sk-club__points--title"
  }, [_vm._v("800 Points")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_vm._v("Free Regular Combo")])])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-icon"
  }, [_c('sk-icon', {
    attrs: {
      "free-movieticket": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('h5', {
    staticClass: "sk-club__points--title"
  }, [_vm._v("1000 Points")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_vm._v("Free Movie Ticket")])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-icon"
  }, [_c('sk-icon', {
    attrs: {
      "prestige-movieticket": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('h5', {
    staticClass: "sk-club__points--title"
  }, [_vm._v("1500 Points")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_vm._v("Free Cine Prestige Movie Ticket")])])])])], 1)], 1)])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('sk-panel', [_c('div', {
    staticClass: "sk-club__points-earn"
  }, [_c('h3', {
    staticClass: "sk-club__points--heading"
  }, [_vm._v("Earn Points")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('div', {
    staticClass: "h1 sk-club__points--title"
  }, [_vm._v("100")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_c('div', [_c('strong', [_vm._v("Points")]), _vm._v(" per Movie Booked")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Points")]), _vm._v(" per Regular Combo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('div', {
    staticClass: "h1 sk-club__points--title"
  }, [_vm._v("200")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_c('div', [_c('strong', [_vm._v("Points")]), _vm._v(" per Must See Movie booked")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Points")]), _vm._v(" per Cine Prestige ticket bought")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Points")]), _vm._v(" per Double Take (sharing) combo")]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Points")]), _vm._v(" per DBox Ticket bought")])])])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points-wrapper"
  }, [_c('div', {
    staticClass: "sk-club__points-copy"
  }, [_c('div', {
    staticClass: "h1 sk-club__points--title"
  }, [_vm._v("2X")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__points--sub-title"
  }, [_c('div', [_c('strong', [_vm._v("Double your points")]), _vm._v(" each Thursday for each movie booked")])])])])])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__section sk-club__join-steps"
  }, [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": ""
    }
  }, [_c('h2', {
    staticClass: "h1 sk-club__join-steps--heading"
  }, [_vm._v("JOIN NOW! IT'S FREE!")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [_c('h5', {
    staticClass: "sk-club__join-steps--heading"
  }, [_vm._v("Join the SK Club online")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Create a profile and join SK Club")]), _vm._v(" "), _c('li', [_vm._v("Click on the activation link")]), _vm._v(" "), _c('li', [_vm._v("Go to your dashboard")]), _vm._v(" "), _c('li', [_vm._v("Link your card")])]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__join-steps--btns"
  }, [_c('sk-button', {
    staticClass: "sk-club__join-steps--join-btn",
    attrs: {
      "primary": "",
      "router": "",
      "to": _vm.isGuest ? {
        name: 'user',
        params: {
          signInType: 'signup'
        }
      } : {
        name: 'profile'
      }
    }
  }, [_vm._v("Join now")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sk-club__section"
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/sk-club/kids.png",
      "alt": "Kids"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_vm._v("Kids")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("\n                          Enjoy a bespoke birthday party experience at any Ster-Kinekor Theatre. "), _c('a', {
    attrs: {
      "href": "mailto:leads@sterkinekor.com"
    }
  }, [_vm._v("Enquire here")])])])])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/sk-club/over-60.png",
      "alt": "Over 60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_vm._v("Over 60")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("22% Off Every Day")])])])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "black": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__reward-icons"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/sk-club/vip.png",
      "alt": "VIP"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--title"
  }, [_vm._v("VIP")]), _vm._v(" "), _c('div', {
    staticClass: "sk-club__reward-icons--sub-title"
  }, [_vm._v("As an SK Club VIP member you get to enjoy exclusive SK CLUB screenings & events, as well as exclusive advanced bookings.")])])])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Discovery_Vitality') ? _c('div', {
    attrs: {
      "id": "discovery-form",
      "data-jump-link-target": ""
    }
  }, [_c('sk-discovery-vitality')], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Discovery_Vitality' || _vm.$route.path === '/club-loyalty/Edgars_Club') ? _c('div', [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.$route.path === '/club-loyalty/Discovery_Vitality') ? _c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Have a look at our vitality pricing guide")]) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Edgars_Club') ? _c('h3', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Have a look at our Edgars Club price list")]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "select-cinema"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a cinema")]), _vm._v(" "), (_vm.cinemas) ? _c('sk-combo-select', {
    staticClass: "cinema-select form-group",
    attrs: {
      "options": _vm.cinemas,
      "track-by": "cinema",
      "label": "cinema",
      "searchable": false,
      "placeholder": "Choose A Cinema",
      "multiple": false
    },
    model: {
      value: (_vm.cinema_selected),
      callback: function($$v) {
        _vm.cinema_selected = $$v
      },
      expression: "cinema_selected"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.cinema_selected != null) ? _c('div', {
    staticClass: "select-cinema-type"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Choose a cinema type")]), _vm._v(" "), _c('div', {
    staticClass: "detail-experience"
  }, [_c('sk-list', [_c('sk-list-tile', [_c('sk-list-tile-action', [_c('span', {
    staticClass: "label label--large",
    class: _vm.active2d ? 'label--active' : '',
    on: {
      "click": function($event) {
        _vm.selectCinemaType(_vm.cinema_selected['2d_vitality'], _vm.cinema_selected['2d_edgars'], _vm.cinema_selected['2d_full_price'], _vm.active2d = true, _vm.active3d = false)
      }
    }
  }, [_vm._v("2D")])])], 1), _vm._v(" "), _c('sk-list-tile', [_c('sk-list-tile-action', [_c('span', {
    staticClass: "label label--large",
    class: _vm.active3d ? 'label--active' : '',
    on: {
      "click": function($event) {
        _vm.selectCinemaType(_vm.cinema_selected['3d_vitality'], _vm.cinema_selected['3d_edgars'], _vm.cinema_selected['3d_full_price'], _vm.active3d = true, _vm.active2d = false)
      }
    }
  }, [_vm._v("3D")])])], 1)], 1)], 1)]) : _vm._e()]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs2": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "prices"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Prices")]), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "prices-box"
  }, [_c('span', [_vm._v("Full Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.fullPrice))])])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md5": ""
    }
  }, [_c('div', {
    staticClass: "prices-box card-name-block"
  }, [(_vm.$route.path == '/club-loyalty/Edgars_Club') ? [_c('span', [_vm._v("Edgars Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.edgarsPrice))])] : _vm._e(), _vm._v(" "), (_vm.$route.path == '/club-loyalty/Discovery_Vitality') ? [_c('span', [_vm._v("Vitality Price")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.vitalityPrice))])] : _vm._e()], 2)])], 1)], 1)])], 1), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Discovery_Vitality' && _vm.showOtherPricing) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Other pricing")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Cinema Nouveau")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Full Price")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R80,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Vitality")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R40,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item"
  }, [_vm._v("Opera")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("NT Live")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Prestige 2D/3D")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("IMAX 2D/3D")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R110,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R156,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R140,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R129,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R60,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R105,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R76,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R72,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("IMAX 3D Glasses")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Vitality Welcome Pack")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Vitality Replacement Pack")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Adults)")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Kids)")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R16,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R44,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R32,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R12,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R11,00")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "inline-block": "",
      "primary": "",
      "tag": "a",
      "href": "#discovery-form"
    }
  }, [_vm._v("Activate Discovery Vitality Now")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/club-loyalty/Edgars_Club' && _vm.showOtherPricing) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('h3', [_vm._v("Other pricing")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Cinema Nouveau")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Full Price")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R80,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_c('strong', [_vm._v("Edgars Club")])]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R40,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item"
  }, [_vm._v("Opera")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("NT Live")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Prestige 2D/3D")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("IMAX 2D/3D")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm2": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R110,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R156,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R140,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R129,00")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R68,50")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R118,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R86,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R86,00")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "table": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("IMAX 3D Glasses")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Adults)")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Standard 3D Glasses (Kids)")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("Edgars Activation")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "table--item no-border"
  }, [_vm._v("R16,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R12,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R11,00")]), _vm._v(" "), _c('div', {
    staticClass: "table--item"
  }, [_vm._v("R30,00")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "inline-block": "",
      "primary": "",
      "tag": "a",
      "href": "http://www.edgarsclub.co.za/benefits/do-more/ster-kinekor/",
      "target": "_blank"
    }
  }, [_vm._v("Visit Edgars Online To Find Out More")])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('sk-signin'), _vm._v(" "), (_vm.movies.now_showing.length > 0) ? [(_vm.movies.now_showing) ? _c('sk-related-movies', {
    attrs: {
      "limit": "6",
      "label": "Now Showing",
      "movies": _vm.movies.now_showing
    }
  }) : _vm._e()] : _vm._e()]], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2d0e86a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/club-loyalty-info/club-loyalty-info.vue
// module id = 608
// module chunks = 0